<template>
	<div>
		<div v-show="Receivable">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">履约分析表</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:10px"></div>
					<div style="display:inline-block;margin-top:20px">
						<span>组织架构</span>
						<el-cascader v-model="project_id" @change="changeCascader" clearable
							style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
					</div>

					<!-- <div style="display:inline-block;margin-top:20px;margin-left:20px">
						<span>欠款金额 </span>
						<el-input v-model="condition.project_name" style="margin-left:10px;width:150px"
							placeholder="请输入欠款金额">
						</el-input>
					</div> -->

					<div style="display:inline-block;margin-top:20px;margin-left:20px">
						<span>区域总监 </span>
						<el-select v-model="condition.area_manager_id" style="margin-left:10px;margin-top:-10px"
							:placeholder="postPlaceholder" clearable>
							<el-option v-for="item in overmanList" :key="item.id" :label="item.staff_name" :value="item.id">
							</el-option>
						</el-select>
					</div>


					<!-- 按钮 -->
					<div style="display:inline-block;margin:20px 20px;">
						<el-button type="goon" @click="Find">查询</el-button>
						<div style="display:inline-block;margin-left:190px">
							<download-excel class="export-excel-wrapper" :fields="download_excel" title="调岗人员清单"
								name="调岗人员清单.xls" :fetch="ExportForm" style="margin-left:-180px;top:100px">
								<el-button type="goon"
									style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
									导出</el-button>
							</download-excel>
						</div>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:1% 3% 0 3%">
					<el-table :data="tableData" :header-cell-style="{background:'#d3eae2',color:'#000000'}"
						:span-method="objectSpanMethod" border @selection-change="handleSelectionChange"
						style="width: 100%" @cell-mouse-leave="cellMouseLeave" :summary-method="getSummaries"
						@cell-mouse-enter="cellMouseEnter" height="600" :cell-class-name="tableRowClassName">
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column align="center" prop="organizeName" label="架构" width="300">
						</el-table-column>
						<el-table-column prop="areaManagerName" align="center" label="区域总监"></el-table-column>
						<el-table-column prop="" align="center" label="项目数量" width="100">
							<template slot-scope="scope">
								<span>{{scope.row.projectQuantity}}</span>
								<el-popover
								    placement="right"
								    title="项目详情"
								    width="300"
								    trigger="click">
									<el-table :show-header="false" :data="gridData">
									    <el-table-column align="center" label="" width="50">
									    	<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
									    </el-table-column>
									    <el-table-column width="200" property="partnerName"></el-table-column>
									    <el-table-column width="50" property="uncollected_payment_money"></el-table-column>
									  </el-table>
									<img src="../../../assets/icon/双箭头下.png" slot="reference" 
									style="width: 16px;height:16px;vertical-align: middle;margin-top: -3px;" @click="areaManager(scope.row)"/>
								</el-popover>
							</template>
						</el-table-column>
						<el-table-column prop="uncollected_payment_money" align="center" label="欠款金额"></el-table-column>
						<el-table-column prop="localProportions" align="center" label="各总监应收占比"></el-table-column>
						<el-table-column prop="localProportion" align="center" label="整体占比"></el-table-column>
					</el-table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				total: 0,
				tableData: [],
				titleData: [],

				download_excel: {},
				// 权限
				Receivable: true,
				showedit: false,
				Popover:false,
				editList: {},
				ids: [],
				//条件
				condition: {
					organize_ids: '',
					area_manager_id: '',
				},
				contract_start_date:[],
				project_id: [],
				orderIndexArr: [],
				hoverOrderArr: [],
				overmanList:[],
				rowIndex:'',

				//回显查询岗位
				project_ide: '',

				//组织架构数据
				organizeList: [],

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: false,
				},
			};
		},
		methods: {
			//组织架构选择
			changeCascader() {
				this.condition.organize_ids = this.project_id[this.project_id.length - 1];
			},
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				});
			},
			async areaManager(e){
				console.log(e)
				var content = {
					area_manager_id: e.area_manager_id,
					organize_ids: e.organize_ids
				}
				var data = await this.$globals.AxiosPost('tenderHonourAgreement/getAnalyseProject', content);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.gridData = data;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			Return() {
				this.showadd = false;
				this.Receivable = true;
				this.trash();
				this.Find();
			},

			// 操作编辑
			edit(e) {
				this.editList = e;
				this.Receivable = false;
				this.showedit = true;
			},
			//查询
			async Find() {
					var data = await this.$globals.AxiosPost('tenderHonourAgreement/getAgreement', this.condition);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data;
						this.getOrderNumber()
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			getOrderNumber() {
				const orderObj = {};
				this.tableData.forEach((item, index) => {
					item.rowIndex = index;
					if (orderObj[item.organizeName]) {
						orderObj[item.organizeName].push(index);
					} else {
						orderObj[item.organizeName] = [];
						orderObj[item.organizeName].push(index);
					}
				});
				// 将数组长度大于1的值 存储到this.orderIndexArr（也就是需要合并的项）
				Object.keys(orderObj).forEach((key) => {
					if (orderObj[key].length > 1) {
						this.orderIndexArr.push(orderObj[key]);
					}
				});
			},
			objectSpanMethod({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (columnIndex === 0 || columnIndex === 1 || columnIndex === 6) {
			
					for (let i = 0; i < this.orderIndexArr.length; i += 1) {
						let element = this.orderIndexArr[i];
						for (let j = 0; j < element.length; j += 1) {
							let item = element[j];
							if (rowIndex === item) {
								if (j === 0) {
									return {
										rowspan: element.length,
										colspan: 1,
									};
								}
								if (j !== 0) {
									return {
										rowspan: 0,
										colspan: 0,
									};
								}
							}
						}
					}
				}
			},
			tableRowClassName({
				row,
				rowIndex
			}) {
				let arr = this.hoverOrderArr;
				for (let i = 0; i < arr.length; i += 1) {
					if (rowIndex === arr[i]) {
						return 'hovered-row';
					}
				}
			},
			cellMouseEnter(row, column, cell, event) {
				this.rowIndex = row.rowIndex;
				this.hoverOrderArr = [];
				this.orderIndexArr.forEach((element) => {
					if (element.indexOf(this.rowIndex) >= 0) {
						this.hoverOrderArr = element;
					}
				});
			},
			cellMouseLeave(row, column, cell, event) {
				this.rowIndex = '-1';
				this.hoverOrderArr = [];
			},

			// 导表
			async ExportForm() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = 'StaffTransfer/selectAlls';
				var record = {
					data_grouping: 'Receivable',
					organize_ids: organize_ids,
					city_id: this.condition.staff.city_id,
					create_time: this.condition.create_time,
					state: this.condition.state,
					applicant_id: this.$globals.user.staff_id,
					staff_name: this.condition.staff.staff_name,
					staff_card: this.condition.staff.staff_card,
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if (data.length > 0) {
							this.$message.success("导表成功！文件下载中！");
							return data;
						} else {
							this.$message.success("没有可以导出的数据！");
							return null;
						}

					} else {
						this.$message.warning(data);
					}
				}
			},

			// 操作删除
			async Del(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}

				var url = "StaffTransfer/del";
				var record = {
					ids: ids,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.trash();
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			closeedit() {
				this.showedit = false;
				this.Receivable = true;
			},
			//分页
			handleCurrentChange(val) {
				this.condition.page_num = val;
				this.Find();
			},
			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
				});
				this.organizeList = this.getTreeData(organizeList.data);

			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			}
		},
		async created() {
			var overmanList = await this.$globals.AxiosPost('tenderHonourAgreement/getStaffList', {});
			this.overmanList = overmanList.data;
			this.organizeFind();
			this.Find();
			
		},
	};
</script>

<style>
	.el-popover__title {
		text-align: center;
		font-weight:600;
	}
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}

	.el-button--pic {
		color: #006E4B;
		background-color: #fff;
		border-color: #006E4B;
		font-size: 10px;
		height: 30px;
		width: 70px;
		padding: 10px;
	}

	.el-button--pic:focus,
	.el-button--pic:hover {
		background: #fff;
		border-color: #05573d;
		color: #006E4B;
	}
</style>



// WEBPACK FOOTER //
// Agreement.vue?b41482ac